import { useNavigate } from "react-router-dom";
import { useLiveQuery } from "dexie-react-hooks";
import { db } from "../schema.dexie";
import { listarAlimentos } from "../db/queries";
import { FoodPhoto } from "../ui/FoodPhoto";
import { IndicadorEvolucao } from "../ui/IndicadorEvolucao";

/** P0.5 — acesso rápido aos alimentos seguros (resolver dias difíceis sem estresse). */
export function Seguros() {
  const nav = useNavigate();
  const alimentos = useLiveQuery(() => listarAlimentos()) ?? [];
  const ofertas = useLiveQuery(() => db.oferta.toArray()) ?? [];
  const seguros = alimentos.filter((a) => a.status === "seguro");

  return (
    <main className="tela">
      <button className="btn btn-fantasma" onClick={() => nav(-1)}>
        ← voltar
      </button>
      <h1 className="tela-titulo">alimentos seguros</h1>
      <p className="tela-sub">o que costuma dar certo, à mão.</p>

      {seguros.length === 0 ? (
        <div className="vazio">
          <span className="emoji" aria-hidden>
            🌿
          </span>
          nenhum alimento marcado como seguro ainda. abra um alimento e toque{" "}
          <strong>seguro</strong> no status (ou o app sugere quando a criança chega em
          "come um pouco" na escada). os seguros aparecem aqui pra acesso rápido.
        </div>
      ) : (
        <div className="lista-cards">
        {seguros.map((a) => (
          <button
            className="card linha-alimento"
            key={a.id}
            onClick={() => nav(`/alimento/${a.id}`)}
          >
            <FoodPhoto fotoId={a.fotos[0]} nome={a.nome} categoria={a.categoria} />
            <div className="crescer">
              <div className="nome">{a.nome}</div>
              {a.marca_produto && <div className="meta">{a.marca_produto}</div>}
              <IndicadorEvolucao alimentoId={a.id} ofertas={ofertas} />
            </div>
            <span aria-hidden>→</span>
          </button>
        ))}
        </div>
      )}
    </main>
  );
}
